import React from "react";
import Link from "next/link";
import { getAssets } from "@unisearch/helpers";
import styles from "./hero.module.scss";

export const UniPageLandingHero = () => {
  return (
    <section className={styles.section_landing_hero}>
      <div className="container">
        <div className={styles.wrapper}>
          <div className={styles.content_left}>
            <h1 className={styles.heading}>
              <span className={styles.text_small_hero}>
                The Most Comprehensive Platform
              </span>{" "}
              Connecting You to Your Right-Fit Students
            </h1>

            <div className={`${styles.image_wrapper} ${styles.mobile}`}>
              <img
                src={getAssets(
                  "assets/images/unipage/the most comprehensive platform.png"
                )}
                alt="the most comprehensive platform"
              />
            </div>
            <p className={styles.sub_text}>
              UniSearch strikes the optimum balance between intelligent systems
              and human expertise in distinct markets with one goal - connecting
              higher education institutions directly with their best-fit
              prospects.
            </p>

            <h4 className={styles.text_highlight_hero}>
              Find your right-fit students from over 1.5 million annual visitors
              in emerging and established markets
            </h4>

            <div className={styles.button_wrapper}>
              <Link legacyBehavior href="/university/booking">
                <a className="btn btn-secondary btn-bg">Book for Demo</a>
              </Link>
            </div>
          </div>
          <div className={styles.content_right}>
            <div className={`${styles.image_wrapper} ${styles.desktop}`}>
              <img
                src={getAssets(
                  "assets/images/unipage/the most comprehensive platform.png"
                )}
                alt="the most comprehensive platform"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UniPageLandingHero;
